<template>
  <div class="studio-CU">
    <v-icon class="close-btn" @click="$emit('closeDialog')">close</v-icon>
    <v-container>
      <h1 class="header-text">
        <span>
          <span v-if="isUpdate">Uređivanje studia</span>
          <span v-else>Dodavanje studia</span>
          <div class="header-text-line"></div>
        </span>
      </h1>
      <v-form class="form">
        <v-flex xs12>
          <v-text-field v-model="studio.Name" label="Naziv"></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field v-model="studio.Index" label="Index"></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-checkbox label="Aktivan" v-model="studio.IsActive"></v-checkbox>
        </v-flex>
        <v-flex xs12 class="text-right">
          <v-btn class="main-btn" v-if="isUpdate" @click="updateStudio">Sačuvaj</v-btn>
          <v-btn class="main-btn" v-else @click="postStudio">Kreiraj</v-btn>
        </v-flex>
      </v-form>
    </v-container>
  </div>
</template>

<script>
export default {
  props: ["studioId", "isUpdate", "dialog"],
  data() {
    return {
      studio: {}
    };
  },
  methods: {
    getStudio() {
      this.$store.state.services.studioService
        .get(this.studioId)
        .then(response => {
          this.studio = response.data;
        });
    },
    postStudio() {
      this.$store.state.services.studioService
        .add(this.studio)
        .then(response => {
          this.$emit("addedOrChanged", response.data);
          this.resetStudio();
        });
    },
    updateStudio() {
      this.$store.state.services.studioService
        .update(this.studio)
        .then(response => {
          this.$emit("addedOrChanged", response.data);
          this.resetStudio();
        });
    },
    resetStudio() {
      this.studio = {};
    }
  },
  watch: {
    dialog() {
      if (this.dialog == false) {
        this.resetStudio();
      } else if (this.isUpdate) {
        this.getStudio();
      }
    }
  }
};
</script>

<style scoped>
.form {
  margin-top: 20px;
}
.close-btn {
  float: right;
}
h2 {
  text-align: center;
}
.studio-CU {
  padding: 10px 15px;
}
.color {
  height: 20px;
  margin-bottom: 15px;
  margin-top: 5px;
}
</style>
